import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const TypesOfLattices = () => (
  <DMModuleSubtopic
    title="Types of lattices"
    videos={[
      "https://www.youtube.com/embed/ABpA0YFFSPs",
      "https://www.youtube.com/embed/A08O-4BdD54",
      "https://www.youtube.com/embed/76-tyj_XOQM",
      "https://www.youtube.com/embed/3O5r7qKgJT4",
      "https://www.youtube.com/embed/Y-PqHZA0wwY",
      "https://www.youtube.com/embed/GZcsGvluOGg",
      "https://www.youtube.com/embed/tSt4Kot1nc0",
      "https://www.youtube.com/embed/Vj4pK9AJHJo",
      "https://www.youtube.com/embed/FdI6XtkOHok"

    ]}
    takeaways={[
        {
            text:"Check theorems in your class notes"
        }
    ]}
    questions={[
      {
        text: "Find whether L1={2,3,4,9,36} , L2={1,2,3,6} are sub lattices of L=({1,2,3,4,6,9,36},|) where '|' represents 'divides' relation"
      },
      {
        text:"State and prove distributive inequality in a Lattice"
      },
      {
        text:"Prove that every chain is a distributive Lattice"
      },
      {
        text:"Prove that in a complemented Lattice: a ≤ b ⇔ a * b' ⇔ a' ⊕ b =1 ⇔ b' ≤ a'"
      },
      {image:"/dm_24.png"}
    ]}
    exampleVideos={[]}
  />
);

export default TypesOfLattices;
